export default __webpack_public_path__ + "static/media/asset04.5667f921.png";